@if (specialisms$ | async; as specialisms) {
  <ng-select
    [searchable]="false"
    [markFirst]="true"
    [clearable]="false"
    [items]="specialisms.specialisms"
    bindLabel="name"
    bindValue="code"
    [ngModel]="selected()"
    (ngModelChange)="selectSpecialism($event)"
  >
    <ng-template ng-option-tmp let-item="item">
      @if (item.name) {
        <div class="specialism-container">
          <div class="custom-option">
            <span class="custom-option-name">
              {{ item.name }}
            </span>
            @if (item.code === selected()) {
              <fa-icon [icon]="faCheck"></fa-icon>
            }
          </div>
        </div>
      }
    </ng-template>
  </ng-select>
}
